/**
 * Loading placeholder for the screens that render with no page frame around
 * them: /callback, and the gates mounted ABOVE `Layout` (ProtectedRoute,
 * FirstRunGate, EnrollmentGate). Those all paint on a bare page, so an inline
 * top-left "Loading…" reads as a half-broken render — and during sign-in it
 * jumps out of the centered "Completing sign in…" the user was just looking at.
 *
 * Page-body loading states stay inline (`p-6`/`p-4` inside the Layout chrome):
 * there the surrounding frame is already painted, so centering to the viewport
 * would be the wrong altitude.
 */
export function FullPageLoading({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-cream">
      <div className="text-slate text-[13px] font-sans">{label}</div>
    </div>
  );
}
